// English translation

const en = {
  "navbar.profile": "Perfil",
  "navbar.signed_as": "Usuario",
  "navbar.signout": "Cerrar sesión",
  "navbar.support": "Soporte",
  "navbar.license": "Licencia",
  "party.party.address": "Dirección",
  "profile.general_information": "Información General",
  "profile.terminal": "Tienda / Terminal",
  "profile.terminal_name": "Nombre",
  "profile.change_password": "Cambiar Contraseña",
  "profile.new_password": "Nueva Contraseña",
  "profile.confirm_password": "Confirmar Contraseña",
  "profile.password_changed": "Contraseña cambiada exitosamente",
  "profile.password_mismatch": "Las contraseñas no coinciden",
  "profile.password_min_length": "La contraseña debe tener al menos 8 caracteres",
  "profile.password_error": "Error al cambiar la contraseña",
  "button.ok": "OK",
  "button.close": "Cerrar",
  "button.cancel": "Cancelar",
  "button.yes": "Si",
  "button.no": "No",
  "button.add": "Agregar",
  "button.confirm": "Confirmar",
  "button.print": "Imprimir",
  "button.save": "Guardar",
  "button.mark_all_read": "Marcar todo leído",
  "button.accept": "Aceptar",
  accept: "Aceptar",
  "board.add_record": "Agregar",
  "board.want_to_save_data": "Desea guardar los cambios?",
  "board.missing_required_fields": "Faltan campos requeridos!",
  "board.record_saved": "Registro guardado!",
  "board.button_delete": "Eliminar",
  "board.button.add": "Agregar",
  "notification.info": "Info",
  "notification.success": "Registro Exitoso",
  "notification.warning": "Advertencia",
  "notification.error": "Error",
  "pagination.results":
    "Mostrando {firstItem} a {lastItem} de {countTotal} resultados",
  "table.no_data": "No hay datos con estos parametros",
  "table.filter_to_see_data": "Filtra para ver datos",
};

export default en;
